/* eslint-disable react/no-multi-comp */
import React, { Component, createRef } from 'react';

import { CardElement, Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { Button } from '@mui/material';

import { getStripeCredentials } from '~/services/PaymentsService';

import ErrorDisplay from '../ErrorDisplay';

const STRIPE_STYLES = {
  base: {
    color: '#2d2926',
    fontSize: '16px',
    fontSmoothing: 'antialiased',
    '::placeholder': { color: '#999999' },
  },
};

class StripeWidgets extends Component {
  constructor(props) {
    super(props);
    this.handlePayment = this.handlePayment.bind(this);
    this.state = { error: false };
    this.cardElementRef = createRef();
  }

  handlePayment(e) {
    e.preventDefault();

    const { stripe, elements, onPayment, customerName, customerId, customerEmail, currencyCode, paymentWillStart } =
      this.props;

    // Get the CardElement instance from elements
    const cardElement = elements.getElement(CardElement);

    if (!cardElement) {
      this.setState({
        error: { message: 'Payment form is not ready. Please try again.' },
      });
      return;
    }

    // stripe.createToken(cardElement);

    // Check if card details are complete
    if (!cardElement || !cardElement._complete) {
      this.setState({
        error: { message: 'Please enter payment details' },
      });
      return;
    }

    paymentWillStart(() => {
      const transaction = {
        owner: { name: customerName },
        id_account: customerId,
        email: customerEmail,
        currency: currencyCode,
        save_card: false,
      };

      stripe
        .createSource(cardElement, {
          type: 'card',
          statement_descriptor: this.props.charge_descriptors[this.props.tenant.brand],
        })
        .then((stripeResponse) => {
          if (stripeResponse.error) {
            this.setState({
              error: stripeResponse.error,
            });
          }

          transaction.token = { id: stripeResponse.source.id };
          onPayment('stripe', transaction);
        })
        .catch((err) => {
          console.warn('Some Error Occured : ', err);
        });
    });
  }

  render() {
    const { disabled } = this.props;
    const { error } = this.state;

    return (
      <div>
        {error?.message && <ErrorDisplay message={error.message} />}

        <CardElement
          hidePostalCode
          onReady={(c) => {
            this._element = c;
          }}
          onFocus={this.useNewCardHandler}
          options={{
            style: STRIPE_STYLES,
          }}
        />

        <Button
          variant="contained"
          color="primary"
          onClick={this.handlePayment}
          className="submit-payment-btn"
          disabled={disabled}
          sx={{ mt: 1 }}
          fullWidth
        >
          Submit Payment
        </Button>
      </div>
    );
  }
}

class StripePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      stripePublishableKey: '',
    };
  }

  componentDidMount() {
    getStripeCredentials()
      .then((response) => {
        this.setState({
          stripePublishableKey: response.result.stripe_publishable_key,
          charge_descriptors: response.result.charge_descriptors,
          dataLoaded: true,
        });
      })
      .catch((error) => {
        this.setState({ error });
      });
  }

  render() {
    const { dataLoaded, error, stripePublishableKey } = this.state;

    if (!dataLoaded) {
      return <div>Loading...</div>;
    }

    if (error) {
      return <div>Error loading the Stripe credentials: {error}</div>;
    }

    const stripePromise = loadStripe(stripePublishableKey);

    return (
      <Elements stripe={stripePromise}>
        <ElementsConsumer>
          {({ stripe, elements }) => (
            <StripeWidgets
              stripe={stripe}
              elements={elements}
              paymentWillStart={this.props.paymentWillStart}
              onPayment={this.props.onPayment}
              customerId={this.props.customerId}
              customerEmail={this.props.customerEmail}
              customerName={this.props.customerName}
              currencyCode={this.props.currencyCode}
              tenant={this.props.tenant}
              getSavedCardsFromStripe={this.props.getSavedCardsFromStripe}
              charge_descriptors={this.state.charge_descriptors}
              disabled={this.props.disabled}
            />
          )}
        </ElementsConsumer>
      </Elements>
    );
  }
}

export default StripePayment;
